import { useContext } from 'react';
import { LayoutContext } from '~contexts/LayoutContext';

function useLayout() {
  return useContext(LayoutContext);
}

export default useLayout;
